export default class Product {
  constructor() {
    this.id = ''
    this.title = ''
    this.procedures = []
  }
}
